export default __webpack_public_path__ + "static/media/Fit_After_50_Logo.e618fee6.svg";